<template>
  <div class="wrapper">
    <div class="hints" v-if="items.length > 0">
      <div
        class="item-hint"
        v-for="(hint, i) in items"
        :key="i"
        @click="setValItem(hint)"
      >
        <span v-if="type !== 'action'">{{ hint.corporate_name }}</span>
        <span v-else>{{ hint.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'HintBox',
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
    },
  },

  methods: {
    ...mapActions('branches', ['setIh1', 'setIh2']),
    setValItem(item) {
      if (this.type === 'ih1') {
        this.setIh1(item._id);
      }

      if (this.type === 'ih2') {
        this.setIh2(item._id);
      }

      if (this.type === 'action') {
        this.$store.state.actions.myActionId = item._id;
        this.$store.state.actions.myActionName = item.name;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  .hints {
    background-color: #fff;
    width: 100%;
    position: absolute;
    border: 1px solid #f1f1f1;

    .item-hint {
      cursor: pointer;
      padding: 8px;
      // text-transform: uppercase;
      &:hover {
        background-color: rgba(0, 0, 0, 0.09);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/hint-box/index.vue